import { useViewModel } from '@rehaje/react'

import { SchemaModel } from '../models/SchemaModel'

export const useSchemaModel = <T extends SchemaModel>(): T | undefined => {
  const model = useViewModel()
  return (model instanceof SchemaModel ? model : undefined) as T | undefined
}
